import * as React from "react";
function SvgCircleHalf(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path fill="currentColor" d="M24 3v42c11.6 0 21-9.4 21-21S35.6 3 24 3z" />
      <circle
        cx={24}
        cy={24}
        r={20.5}
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={3}
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCircleHalf);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
